module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_2-1.58c372b4.svg";